import React, { Component } from "react";
import qs from "qs"; // TODO: document
import _ from "lodash";
import { Modal } from "antd";
import {
  redirectToPatientSite,
  redirectToLoggedInSite
} from "./ClinicLoginActions";
import ClinicLoginView from "./ClinicLoginView";
import {
  history,
  decryptId,
  setPageMetaDesc,
  getBrowserDetails,
  setPhoneLimit,
  encryptId,
  handleRedirectUserToSelectedPage
} from "../../../helpers";
import { postLogin } from "../../../services";
import { FaHospital, FaUserAlt } from "react-icons/fa";
import { defaultCountryObj } from "../../../helpers/CountryCodeOptions";

class ClinicLoginContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: "",
      password: "",
      error: false,
      errorMsg: "",
      serverErrorText: "",
      serverError: false,
      utmSource: null,
      utmMedium: null,
      utmContent: null,
      utmCampaign: null,
      inviteCode: null,
      doctorName: null,
      docId: null,
      signupIntent: null,
      testValue: null,
      isSignedIn: false,
      showSelectAccountModal: false,
      signInResponse: null,
      countryCode: defaultCountryObj?.country_code,
      accountType: null
    };
  }

  componentDidMount() {
    // The following code will be used to setup the meta information for sign in page
    this.handleSetMetaContent();
    // the following code handles fetching any querystring parameters in the url,
    // so that the parameters can be stored in database, also this is function handles retaining the url parameters
    // accross the other url also
    this.fetchUTMParams();
  }

  /**
   * @function handleSetMetaContent
   * @param nothing
   * @desc Function handles setting the title to the sign up page, for SEO purpose.
   * This function handles setting meta content for a page
   */
  handleSetMetaContent = () => {
    document.title = "Sign In";
    // set meta description for login page
    setPageMetaDesc("Sign in to Kulcare");
  };

  /**
   * @function loginAction
   * @param phoneNumber
   * @param password
   * @desc This function handles logging in the user into the kulcare app, consuming phone number and password
   */
  loginAction = (phoneNumber, password, utmParams) => {
    const { countryCode } = this.state;
    this.setState({ isProcessing: true });

    let mixpanel_data = getBrowserDetails();
    mixpanel_data.app = "Doctor";
    const signInObj = {
      user_signin_form: {
        country_code: countryCode,
        phone_number: phoneNumber,
        password
      },
      platform: "web",
      mixpanel_data: mixpanel_data
    };

    if (utmParams) {
      signInObj.utm_params = {
        utm_medium: utmParams.utm_medium,
        utm_source: utmParams.utm_source,
        utm_content: utmParams.utm_content,
        utm_campaign: utmParams.utm_campaign
      };
    }
    // if the user has signed in from mobile, then prompt user to continue rest of the app through web
    postLogin(signInObj).then(response => {
      // login successful
      this.setState({ isProcessing: false });
      if (response?.data?.data && response?.data?.data?.user) {
        const responseObj = response.data;
        let userAccounts = responseObj?.data?.user?.user_accounts;

        // fetch patient accounts from account_type object from user object
        const patientAccount = userAccounts?.filter(obj => {
          if (obj.account_type === "patient") return obj;
        });
        // if the user has more than 1 accounts and a patient account present
        // then show a "Select account type" modal for taking the user into respective application
        // Choosing Patient type account from modal, will take user to Patient application
        // Choosing Provider type account from modal, will take user to Provider application
        if (userAccounts.length > 1 && patientAccount.length > 0) {
          this.setState({
            showSelectAccountModal: true, // variable for showing Select account type modal
            signInResponse: responseObj
          });
        } else if (!responseObj?.data?.user?.pwd_set_by_user) {
          // handle the case when user has not set its password by its own, its been set by kulcare admin
          // this case covers hospital sign up, when a hospital is signed up by kulcare admin and the hospital has not set its password by its own
          const id = encryptId(responseObj?.data?.user?.id);
          localStorage.setItem("atk", responseObj?.auth_token);
          localStorage.setItem(
            "pwd_set_by_user",
            responseObj?.data?.user?.pwd_set_by_user
          );
          // redirect user to reset password page, so that it can set the password by its own
          history.push(`/reset-password?id=${id}`);
        } else if (responseObj?.data?.user?.signed_up_as === "patient") {
          // if user is signed up as patient, then take the patient to logged in site for patient
          redirectToPatientSite(false, responseObj);
        } else {
          // else redirect user to provider application
          redirectToLoggedInSite(responseObj, null, null, "login");
        }
      } else if (response?.data?.errors) {
        // handle the failure case
        this.processErrors(response);
      }
    });
  };

  /**
   * @function fetchUTMParams
   * @desc This funtion fetches utm params from the url, and retain it for the user in database as well as auth routes
   */
  fetchUTMParams = () => {
    const params = qs.parse(this.props.location.search.slice(1));

    if (params && !_.isEmpty(params)) {
      const {
        utm_source,
        utm_medium,
        utm_content,
        utm_campaign,
        kic,
        dname,
        did,
        su_int,
        a6t,
        acc
      } = params;
      this.setState({
        utmSource: utm_source || null,
        utmMedium: utm_medium || null,
        utmContent: utm_content || null,
        utmCampaign: utm_campaign || null,
        inviteCode: kic || null,
        doctorName: dname || null,
        docId: did ? decryptId(did) : null,
        signupIntent: su_int || null,
        testValue: a6t || null,
        accountType: acc || null
      });
    }
  };

  /**
   * @function handleChange
   * @param e
   * @desc This handles the phone number and password input changes
   */
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value.replace(/\s/g, ""),
      serverErrorText: ""
    });
  };

  /**
   * @function setStateForInvalidData
   * @param errorText
   * @return nothing
   * @desc This method sets error messages state
   */
  setStateForInvalidData = errorText => {
    this.setState({
      serverErrorText: errorText
    });
  };

  /**
   * @function handleSubmit
   * @param e
   * @desc This handles the submission of login parameters, calls login action
   */
  handleSubmit = e => {
    e.preventDefault();
    const {
      phoneNumber,
      password,
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign
    } = this.state;
    let utmParams = null;
    // Error handling before submission of login parametes
    if (!phoneNumber || !password) {
      this.setStateForInvalidData("Mobile number and password are required");
      return false;
    }

    if (phoneNumber && phoneNumber.length < 10) {
      this.setStateForInvalidData("Enter valid mobile number");
      return false;
    }

    if (password && password.length < 8) {
      this.setStateForInvalidData("Password is too short");
      return false;
    }

    if (utmSource || utmMedium || utmContent || utmCampaign) {
      utmParams = {
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        param_type: "utm"
      };
    }

    if (phoneNumber && password) {
      // process to login the user if phone number and password are entered and valid, along with the utm parameters
      this.loginAction(phoneNumber, password, utmParams);
    }
  };

  /**
   * @function processErrors
   * @param errors
   * @param nothing
   * @desc This handles setting state
   *  of variable which
   * is to be shown to the user
   *  when api returns some error
   */
  processErrors = errors => {
    if (errors?.data?.errors?.length > 0) {
      if (errors.data.errors[0].source === "account") {
        this.setState({ isSignedIn: true });
      } else {
        this.setState({
          serverErrorText: errors.data.errors[0].title
        });
      }
    }
  };

  /**
   * @function redirectUserToPage
   * @desc This function handles redirection to given page, along with the query parameters
   */
  redirectUserToPage = (e, pageString) => {
    if (e) e.preventDefault();
    const {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      inviteCode,
      doctorName,
      docId,
      signupIntent,
      testValue,
      accountType
    } = this.state;
    const params = {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      inviteCode,
      doctorName,
      docId,
      accountType,
      signupIntent,
      testValue
    };
    handleRedirectUserToSelectedPage(pageString, params);
  };

  /**
   * @function toggleModal
   * @desc This function handles hiding the Select account modal, modal to allow user to choose between provider or patient application
   */
  toggleModal = () => {
    this.setState({ showSelectAccountModal: false });
  };

  handleCodeChange = (countryCode, countryCodeObj) => {
    this.setState({
      phoneNumberLengthLimit: setPhoneLimit[countryCode],
      countryCode
    });
  };

  render() {
    let fromStaff = false;

    if (this.props.location) {
      fromStaff = this.props.location.pathname === "/sign-in/fs";
    }
    const {
      isSignedIn,
      countryCode,
      showSelectAccountModal,
      signInResponse,
      accountType
    } = this.state;
    return (
      <>
        <ClinicLoginView
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          isProcessing={this.state.isProcessing}
          error={this.state.error}
          errorMsg={this.state.errorMsg}
          phoneNumber={this.state.phoneNumber}
          password={this.state.password}
          loginError={this.props.loginError}
          serverError={this.state.serverError}
          serverErrorText={this.state.serverErrorText}
          fromStaff={fromStaff}
          redirectUserToPage={this.redirectUserToPage}
          isSignedIn={isSignedIn}
          countryCode={countryCode}
          handleCodeChange={this.handleCodeChange}
          accountType={accountType}
        />
        {/* SELECT ACCOUNT MODAL: a modal that allows user to choose between provider or patient application, on sign in */}
        <Modal
          title={null}
          visible={showSelectAccountModal}
          footer={null}
          onCancel={this.toggleModal}
          className="kc-modal-medium no-footer text-type-modal"
          centered
        >
          <div className="website-modal-wrapper">
            <div className="heading text-center mb-20">
              Choose an account to continue with
            </div>
            <div className="description mb-0">
              <ul className="account-types-list">
                {/* Practice or Provider account */}
                <li>
                  <div
                    onClick={e => {
                      if (e) e.preventDefault();
                      redirectToLoggedInSite(
                        signInResponse,
                        null,
                        null,
                        "login"
                      );
                    }}
                  >
                    <div className="icon-box">
                      <FaHospital size={30} color="#656565" />
                    </div>
                    <div>Practice</div>
                  </div>
                </li>
                {/* Patient account */}
                <li>
                  <div
                    onClick={e => {
                      if (e) e.preventDefault();
                      redirectToPatientSite(false, signInResponse);
                    }}
                  >
                    <div className="icon-box">
                      <FaUserAlt size={30} color="#656565" />
                    </div>
                    <div>Patient</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default ClinicLoginContainer;
